import React, { Component } from 'react';

class SocialItemComponent extends Component {
    render() {
        return (
            <li className={this.props.className}>
                <a href={this.props.url} target="_blank" title={this.props.title}/>
            </li>
        );
    }
}

export default SocialItemComponent;



// WEBPACK FOOTER //
// ./src/components/hello/socialMedia/social.item.component.jsx